import React from "react";
import styles from "./styles.module.scss";
import { SectionFour } from "./sectionFour";
import { BeforeFooterComponent } from "components";
import { BalconyChilling } from "assets";
import { SectionTwo } from "./sectionTwo";
import { SectionOne } from "./sectionOne";
const BookingUI = () => {
	return (
		<>
			<SectionOne />
			<SectionTwo />
			<SectionFour />
			<BeforeFooterComponent
				image={BalconyChilling}
				templateTextColor="black"
				backgroundColor="#F6F5E1"
				paragraph="Experience unparalleled comfort and personalized service. Your satisfaction is our priority – enjoy a truly exceptional stay with us."
				heading="DISCOVER REFINED LUXURY"
				headingColor="black"
				paragraphColor="black"
				rotatingArrowColor="black"
			/>
		</>
	);
};

export { BookingUI };
